import Vue from 'vue'
import Router from 'vue-router'

const Index = () => import('@/views/Index')

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// User
const UserInfo = () => import('@/views/user/Info')
const UserDomainList = () => import('@/views/user/DomainList')
const UserDomainView = () => import('@/views/user/DomainView')

//Router
const RouterList = () => import('@/views/router/List')
const RouterView = () => import('@/views/router/View')
const RouterAdd = () => import('@/views/router/Add')
const RouterAuth = () => import('@/views/router/Auth')

//Region
const RegionList = () => import('@/views/router/RegionList')

//Router-ID
const RouterIdList = () => import('@/views/router/RouterIdList')

//Port Forward
const PortForwardList = () => import('@/views/portforward/PortForwardList')

//Routing Filter
const RoutingFilterList = () => import('@/views/routing/FilterList')
const RoutingFilterDetail = () => import('@/views/routing/FilterDetail')
const RoutingRouterStates = () => import('@/views/routing/RouterStates')

//Routing Rule
const RoutingRuleList = () => import('@/views/routing/RuleList')

//OSPF
const OspfList = () => import('@/views/routing/OspfList')

//BGP
const BgpList = () => import('@/views/routing/BgpList')

//OpenVPN
const OpenVpnList = () => import('@/views/routing/OpenVpnList')

//Static Route & Address List
const StaticRouteList = () => import('@/views/routing/StaticRouteList')
const AddressListList = () => import('@/views/routing/AddressListList')

//Route Group
const RouteGroupList = () => import('@/views/routing/RouteGroupList')
const RouteGroupDetail = () => import('@/views/routing/RouteGroupDetail')

//BGP Endpoint
const BgpEndpointList = () => import('@/views/routing/BgpEndpointList')

//Link IP
const LinkIpList = () => import('@/views/routing/LinkIpList')

//Tunnel
const TunnelList = () => import('@/views/tunnel/TunnelList')
const TunnelEndpointList = () => import('@/views/tunnel/EndpointList')

//Interface & IP Management
const InterfaceManagement = () => import('@/views/router/InterfaceManagement')
const IpAddressManagement = () => import('@/views/router/IpAddressManagement')

//System
const SystemLogs = () => import('@/views/system/Logs')

//CMDB
const CMDBDeviceList = () => import('@/views/cmdb/DeviceList')
const CMDBDAddDevice = () => import('@/views/cmdb/AddDevice')
const CMDBDViewDevice = () => import('@/views/cmdb/ViewDevice')

//DDNS
const DDNSList = () => import('@/views/ddns/List')
const DDNSAdd = () => import('@/views/ddns/Add')

// Auth
const Login = () => import('@/views/auth/Login')
const Logout = () => import('@/views/auth/Logout')
const Register = () => import('@/views/auth/Register')
const PageNotFound = () => import('@/views/404')



Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/index',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'index',
          name: 'Index',
          component: Index
        },

      ]
    },
    {
      path: '/router',
      redirect: '/router',
      name: 'Router',
      component: TheContainer,
      children: [
        {
          path: '',
          name: 'List',
          component: RouterList
        },
        {
          path: 'view/:id',
          name: 'View',
          component: RouterView
        },
        {
          path: 'add',
          name: 'Add',
          component: RouterAdd
        },
        {
          path: 'auth',
          name: 'Share Router',
          component: RouterAuth
        },
      ]
    },
    {
      path: '/port-forward',
      redirect: '/port-forward',
      name: 'Port Forward',
      component: TheContainer,
      children: [
        {
          path: '',
          name: 'List',
          component: PortForwardList
        },

      ]
    },
    {
      path: '/tunnel',
      redirect: '/tunnel/list',
      name: 'Tunnels',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'TunnelList',
          component: TunnelList
        },
        {
          path: 'endpoint',
          name: 'TunnelEndpoints',
          component: TunnelEndpointList
        },
      ]
    },
    {
      path: '/interface',
      redirect: '/interface/list',
      name: 'Interfaces',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'InterfaceManagement',
          component: InterfaceManagement
        },
      ]
    },
    {
      path: '/ip',
      redirect: '/ip/list',
      name: 'IP Addresses',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'IpAddressManagement',
          component: IpAddressManagement
        },
      ]
    },
    {
      path: '/routing/filter',
      redirect: '/routing/filter/chains',
      name: 'Routing Filter',
      component: TheContainer,
      children: [
        {
          path: 'chains',
          name: 'RoutingFilterList',
          component: RoutingFilterList
        },
        // 兼容旧链接
        { path: 'global', redirect: '/routing/filter/chains' },
        { path: 'local', redirect: '/routing/filter/chains' },
        {
          path: 'chain/:id',
          name: 'RoutingFilterDetail',
          meta: { label: 'Chain' },
          component: RoutingFilterDetail
        },
        {
          path: 'states',
          name: 'RoutingRouterStates',
          component: RoutingRouterStates
        },
        // 兼容旧链接（旧路径含 /router 子串会误触发侧边栏 Router 菜单展开）
        { path: 'router-states', redirect: '/routing/filter/states' },
        { path: 'sync-logs', redirect: '/system/logs' }
      ]
    },
    {
      path: '/routing/rule',
      redirect: '/routing/rule/list',
      name: 'Routing Rule',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'RoutingRuleList',
          component: RoutingRuleList
        }
      ]
    },
    {
      path: '/routing/ospf',
      redirect: '/routing/ospf/list',
      name: 'OSPF',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'OspfList',
          component: OspfList
        }
      ]
    },
    {
      path: '/routing/openvpn',
      redirect: '/routing/openvpn/list',
      name: 'OpenVPN',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'OpenVpnList',
          component: OpenVpnList
        }
      ]
    },
    {
      path: '/routing/bgp',
      redirect: '/routing/bgp/list',
      name: 'BGP',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'BgpList',
          component: BgpList
        },
        {
          path: 'endpoint',
          name: 'BgpEndpointList',
          component: BgpEndpointList
        }
      ]
    },
    {
      path: '/routing/static-route',
      redirect: '/routing/static-route/list',
      name: 'Static Routes',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'StaticRouteList',
          component: StaticRouteList
        }
      ]
    },
    {
      path: '/routing/route-group',
      redirect: '/routing/route-group/list',
      name: 'Route Groups',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'RouteGroupList',
          component: RouteGroupList
        },
        {
          path: 'group/:id',
          name: 'RouteGroupDetail',
          component: RouteGroupDetail
        }
      ]
    },
    {
      path: '/routing/address-list',
      redirect: '/routing/address-list/list',
      name: 'Address Lists',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'AddressListList',
          component: AddressListList
        }
      ]
    },
    {
      path: '/link-ip',
      redirect: '/link-ip/list',
      name: 'Link IPs',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'LinkIpList',
          component: LinkIpList
        }
      ]
    },
    {
      path: '/region',
      redirect: '/region/list',
      name: 'Regions',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'RegionList',
          component: RegionList
        }
      ]
    },
    {
      path: '/router-id',
      redirect: '/router-id/list',
      name: 'Router IDs',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'RouterIdList',
          component: RouterIdList
        }
      ]
    },
    {
      path: '/system',
      redirect: '/system/logs',
      component: TheContainer,
      children: [
        {
          path: 'logs',
          name: 'SystemLogs',
          component: SystemLogs
        }
      ]
    },
    {
      path: '/cmdb',
      redirect: '/cmdb/device',
      name: 'CMDB',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'device',
          name: 'Device',
          component: TheContainer,
          redirect: '/cmdb/device',
          children: [
            {
              path: '',
              name: 'List',
              component: CMDBDeviceList
            },
            {
              path: 'add',
              name: 'AddDevice',
              component: CMDBDAddDevice
            },
            {
              path: 'view/:id',
              name: 'View',
              component: CMDBDViewDevice
            },
          ]
        }
      ]
    },
    {
      path: '/ddns',
      redirect: '/ddns/list',
      name: 'DDNS',
      component: TheContainer,
      children: [
        {
          path: 'list',
          name: 'List',
          component: DDNSList
        },
        {
          path: 'add',
          name: 'AddDevice',
          component: DDNSAdd
        }
      ]
    },
    {
      path: '/auth',
      redirect: '/index',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'logout',
          name: 'Logout',
          component: Logout
        }
      ]
    },
    {
      path: '/user',
      redirect: '/user/info',
      name: 'User',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'info',
          redirect: '/user/info',
          component: TheContainer,
          children: [
            {
              path: '',
              name: 'Info',
              component: UserInfo
            },
          ]
        },
        {
          path: 'domain',
          name: 'Domain',
          redirect: '/user/domain',
          component: TheContainer,
          children: [
            {
              path: '',
              component: UserDomainList
            },
            {
              path: ':id',
              name: 'View',
              component: UserDomainView
            }
          ]
        },
      ]
    },
    {
      path: '/404',
      name: 'Page Not Found',
      component: PageNotFound
    },
    {
      path: '*',
      name: 'Page Not Found',
      component: PageNotFound
    }
  ]
}

